var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { persistent: "", width: "950" },
      model: {
        value: _vm.dialog,
        callback: function($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog"
      }
    },
    [
      _c("modificarIncrementoDetalle"),
      _vm._v(" "),
      _c(
        "v-card",
        { staticClass: "p-0" },
        [
          _c(
            "v-card-title",
            { staticClass: "headline" },
            [
              _c(
                "v-flex",
                { attrs: { xs9: "" } },
                [
                  _c("v-icon", [_vm._v(_vm._s(_vm.form.id ? "edit" : "add"))]),
                  _vm._v(
                    "\n          " +
                      _vm._s(
                        _vm.form.id
                          ? "Editar Incremento Salarial por cargo"
                          : "Crear Incremento Salarial por pago"
                      ) +
                      " \n       \n        "
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { icon: "" },
                  nativeOn: {
                    click: function($event) {
                      return _vm.close()
                    }
                  }
                },
                [_c("v-icon", [_vm._v("close")])],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-form",
            {
              ref: "form",
              attrs: { "lazy-validation": "" },
              model: {
                value: _vm.valid,
                callback: function($$v) {
                  _vm.valid = $$v
                },
                expression: "valid"
              }
            },
            [
              _c(
                "v-card-text",
                [
                  _c(
                    "v-container",
                    {
                      staticStyle: { "min-width": "100%" },
                      attrs: { "grid-list-md": "" }
                    },
                    [
                      _c(
                        "v-layout",
                        { attrs: { wrap: "", row: "" } },
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", md6: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: "Fecha de ejecución",
                                  rules: _vm.$validate(["required"]),
                                  required: "",
                                  type: "date",
                                  outline: "",
                                  success: "",
                                  clearable: ""
                                },
                                on: {
                                  input: function($event) {
                                    return _vm.obtenerGestion()
                                  }
                                },
                                model: {
                                  value: _vm.form.fecha_ejecucion,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "fecha_ejecucion", $$v)
                                  },
                                  expression: "form.fecha_ejecucion"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", md6: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: "Gestión",
                                  rules: _vm.$validate(["required"]),
                                  required: "",
                                  disabled: "",
                                  outline: "",
                                  success: "",
                                  clearable: ""
                                },
                                model: {
                                  value: _vm.form.gestion,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "gestion", $$v)
                                  },
                                  expression: "form.gestion"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", md6: "" } },
                            [
                              _c("v-autocomplete", {
                                attrs: {
                                  items: _vm.lista_cargos,
                                  "item-text": "cargo",
                                  "item-value": "id_cargo",
                                  label: "Seleccione el cargo",
                                  outline: "",
                                  success: "",
                                  clearable: ""
                                },
                                on: {
                                  input: function($event) {
                                    return _vm.cargarHaber()
                                  }
                                },
                                model: {
                                  value: _vm.form.id_cargo,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "id_cargo", $$v)
                                  },
                                  expression: "form.id_cargo"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", md6: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: "Porcentaje de incremento (%)",
                                  rules: _vm.$validate(["required"]),
                                  required: "",
                                  type: "number",
                                  outline: "",
                                  success: "",
                                  clearable: ""
                                },
                                on: {
                                  input: function($event) {
                                    return _vm.cargarHaber()
                                  }
                                },
                                model: {
                                  value: _vm.form.incremento_porcentaje,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.form,
                                      "incremento_porcentaje",
                                      $$v
                                    )
                                  },
                                  expression: "form.incremento_porcentaje"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", md6: "" } },
                            [
                              _vm.form.id_cargo
                                ? _c("v-text-field", {
                                    attrs: {
                                      label: "Haber básico actual",
                                      rules: _vm.$validate(["required"]),
                                      required: "",
                                      type: "number",
                                      outline: "",
                                      success: "",
                                      clearable: "",
                                      disabled: ""
                                    },
                                    model: {
                                      value: _vm.form.haber_actual,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "haber_actual", $$v)
                                      },
                                      expression: "form.haber_actual"
                                    }
                                  })
                                : _vm._e()
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", md6: "" } },
                            [
                              _vm.form.id_cargo && _vm.form.haber_actual
                                ? _c("v-text-field", {
                                    attrs: {
                                      label: "Haber básico incrementado",
                                      rules: _vm.$validate(["required"]),
                                      required: "",
                                      type: "number",
                                      outline: "",
                                      success: "",
                                      clearable: "",
                                      disabled: ""
                                    },
                                    model: {
                                      value: _vm.form.haber_incrementado,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.form,
                                          "haber_incrementado",
                                          $$v
                                        )
                                      },
                                      expression: "form.haber_incrementado"
                                    }
                                  })
                                : _vm._e()
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", md12: "" } },
                            [
                              _c("v-spacer"),
                              _vm._v(" "),
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    color: "rgb(147,13,242)",
                                    block: "",
                                    dark: "",
                                    disabled:
                                      !_vm.form.haber_actual ||
                                      !_vm.form.haber_incrementado ||
                                      !_vm.form.incremento_porcentaje ||
                                      !_vm.form.id_cargo
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.adicionarDetalle()
                                    }
                                  }
                                },
                                [
                                  _c("v-icon", [_vm._v("arrow_downward")]),
                                  _vm._v(
                                    "\n                  Registrar\n                "
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-form",
            [
              _c(
                "v-card-text",
                [
                  _c(
                    "v-container",
                    [
                      _c("h3", [
                        _c("strong", [
                          _vm._v("Listado de incrementos salariales")
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs12: "" } },
                            [
                              _c("v-data-table", {
                                staticClass: "elevation-1",
                                attrs: {
                                  items: _vm.incremento_salarial_detalles,
                                  headers: _vm.headers_detalles
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "items",
                                    fn: function(props) {
                                      return [
                                        _c(
                                          "td",
                                          { staticClass: "text-xs-center" },
                                          [
                                            _vm._v(
                                              "\n                      " +
                                                _vm._s(props.item.cargo) +
                                                "\n                    "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "td",
                                          { staticClass: "text-xs-center" },
                                          [
                                            _vm._v(
                                              _vm._s(props.item.porcentaje)
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "td",
                                          { staticClass: "text-xs-center" },
                                          [
                                            _vm._v(
                                              "\n                      " +
                                                _vm._s(
                                                  props.item.haber_basico_actual
                                                ) +
                                                "\n                    "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "td",
                                          { staticClass: "text-xs-center" },
                                          [
                                            _vm._v(
                                              "\n                      " +
                                                _vm._s(
                                                  props.item
                                                    .haber_basico_incrementado
                                                ) +
                                                "\n                    "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "td",
                                          { staticClass: "text-xs-center" },
                                          [
                                            _c(
                                              "v-btn",
                                              {
                                                attrs: {
                                                  color: "error",
                                                  icon: "",
                                                  title: "Eliminar registro"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.eliminarIncremento(
                                                      props.item
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _c("v-icon", [_vm._v("delete")])
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-btn",
                                              {
                                                attrs: {
                                                  color: "warning",
                                                  icon: "",
                                                  title: "Modificar registro"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.modificarIncrementoDetalle(
                                                      props.item
                                                    )
                                                  }
                                                }
                                              },
                                              [_c("v-icon", [_vm._v("edit")])],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ]
                                    }
                                  }
                                ])
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("v-layout", { staticClass: "pa-2" })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c(
                    "v-btn",
                    {
                      nativeOn: {
                        click: function($event) {
                          return _vm.close()
                        }
                      }
                    },
                    [
                      _c("v-icon", [_vm._v("cancel")]),
                      _vm._v(" CERRAR\n          ")
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-56c78fcd", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-56c78fcd","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/incremento_salarial/dialogs/CrearActualizarIncrementoSalarial.vue
// module id = null
// module chunks = 